import { TicketTypesService } from '../services/TicketTypesService';

export function useTicketTypesService(): TicketTypesService {
  return new TicketTypesService(useApiClient(), useUserStore());
}
